<p-dialog
  #orgSelector
  [(visible)]="orgSelectorVisible"
  [blockScroll]="true"
  [closable]="true"
  [class]="'dialog-no-padding'"
  [closeOnEscape]="true"
  [style]="{ width: '850px', height: '700px' }"
  [modal]="true"
  [responsive]="true"
>
  <p-header>
    <span style="font-weight: bold; display: inline-block; padding-left: 8px"
      >Add Number to Organisation</span
    >
  </p-header>
  <div style="height: 100%">
    <add-number-select-user-org></add-number-select-user-org>
    <p-tabView [style]="{ height: '570px' }" [class]="'panel-padding-1'">
      <p-tabPanel header="Organisation Search">
        <add-number-organisation-search></add-number-organisation-search>
      </p-tabPanel>

      <p-tabPanel header="Job Search">
        <add-number-job-search></add-number-job-search>
      </p-tabPanel>
    </p-tabView>
  </div>

  <p-footer>
    <div class="add-number-footer">
      <div class="add-number-display" style="flex-grow: 1">
        <div>
          <span *ngIf="selectedUser" class="selected-org-info">{{ selectedUser.name }} / </span>
          <span *ngIf="selectedOrg" class="selected-org-info">{{ selectedOrg.name }}</span>
        </div>
        <div *ngIf="callerInfo" class="caller-info-number">
          {{ callerInfo.phoneNumber }}
        </div>
      </div>
      <div style="flex-shrink: 1">
        <button pButton label="Cancel" class="ui-button-secondary" (click)="cancel()"></button>
        <button
          pButton
          [disabled]="!selectedOrg"
          label="Add Number"
          class="ui-button-primary"
          (click)="addNumber()"
        ></button>
      </div>
    </div>
  </p-footer>
</p-dialog>
